import React, { RefObject } from 'react';

import { Editor, EditorContent } from '@tiptap/react';
import { FloatingMenu, BubbleMenu } from '@tiptap/react/menus';

import { MenuContent } from './MenuContent/MenuContent';

import classes from './EditorInput.module.scss';

export type EditorInputProps = {
  editor: Editor;
  ref: RefObject<HTMLDivElement>;
};

// Must stay outside component — new object ref on each render causes FloatingMenu remount
const floatingMenuOptions = {
  placement: 'top',
} as const;

const EditorInput = ({ editor, ref }: EditorInputProps) => {
  return (
    <div ref={ref} className={classes.editorInputContainer}>
      <EditorContent editor={editor} />
      <FloatingMenu editor={editor} options={floatingMenuOptions}>
        <MenuContent editor={editor} />
      </FloatingMenu>
      {/* Setting updateDelay and resizeDelay to 0 to prevent "Cannot read properties 
        of null (reading 'domFromPos')" error on unmount. This is a TipTap bug where 
        debounce timers (resizeDebounceTimer, updateDebounceTimer) are not cleared 
        in destroy(), causing position updates to fire after the editor view is gone. */}
      <BubbleMenu editor={editor} updateDelay={0} resizeDelay={0}>
        <MenuContent editor={editor} />
      </BubbleMenu>
    </div>
  );
};

export { EditorInput };
